import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, Fingerprint } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const UltraAdminLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('cop31_ultra_token');
    if (token) navigate('/ultra-admin/dashboard');
  }, [navigate]);

  const handlePasskey = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await axios.post(`${API}/auth/login-bypass`, { role: 'ultra_admin' });
      localStorage.setItem('cop31_ultra_token', res.data.access_token);
      localStorage.setItem('cop31_ultra_user', JSON.stringify(res.data));
      localStorage.setItem('cop31_ultra_login_time', String(Date.now()));
      navigate('/ultra-admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Giriş başarısız.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-emerald-900 to-slate-900 flex items-center justify-center p-4">
      <button onClick={() => navigate('/')} className="absolute top-6 left-6 text-white/50 hover:text-white text-sm transition-colors">
        ← Home
      </button>

      <div className="w-full max-w-sm text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-emerald-500/20 border border-emerald-500/30 rounded-3xl mb-6">
          <Shield className="w-10 h-10 text-emerald-400" />
        </div>
        <h1 className="font-playfair text-3xl text-white font-medium mb-1 tracking-tight">Ultra Admin</h1>
        <p className="text-white/40 text-sm mb-10">COP 31 Antalya · Platform Control Center</p>

        {error && (
          <div className="bg-red-500/10 border border-red-500/20 text-red-400 text-sm px-4 py-3 rounded-2xl mb-6">
            {error}
          </div>
        )}

        <button
          data-testid="passkey-btn"
          onClick={handlePasskey}
          disabled={loading}
          className="w-full bg-emerald-500 hover:bg-emerald-400 disabled:opacity-60 text-white font-bold py-5 rounded-2xl transition-all flex items-center justify-center gap-3 text-lg shadow-lg shadow-emerald-900/50 hover:shadow-xl hover:shadow-emerald-900/50 hover:-translate-y-0.5 transform"
        >
          <Fingerprint className="h-6 w-6" />
          {loading ? 'Giriş yapılıyor...' : 'Passkey ile Giriş'}
        </button>

        <p className="text-white/20 text-xs mt-8">© {new Date().getFullYear()} COP 31 · Antalya</p>
      </div>
    </div>
  );
};

export default UltraAdminLogin;
